import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Home from './pages/Home/Home';
import './App.css'; // Global or app-wide styles

// Import other individual components for routing if needed
import About from './components/About/About';
import Portfolio from './components/Portfolio/Portfolio';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';

// Legal pages
import LiftLogLanding from './pages/LifeLog/LiftLog';
import LiftLogSupport from './pages/LifeLog/Support';
import LiftLogTerms from './pages/LifeLog/Terms';
import LiftLogPrivacy from './pages/LifeLog/Privacy';
import CVProTerms from './pages/CVPro/Terms';
import CVProPrivacy from './pages/CVPro/Privacy';
import InvoSyncTerms from './pages/InvoSync/Terms';
import InvoSyncPrivacy from './pages/InvoSync/Privacy';
import RelayrLanding from './pages/Relayr/Relayr';
import RelayrSupport from './pages/Relayr/Support';
import RelayrTerms from './pages/Relayr/Terms';
import RelayrPrivacy from './pages/Relayr/Privacy';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#F5F5F7',
        },
        background: {
            default: '#0F1113',
            paper: '#161819',
        },
    },
    typography: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        h4: { fontWeight: 700, letterSpacing: '-0.03em' },
        h5: { fontWeight: 600, letterSpacing: '-0.02em' },
        h6: { fontWeight: 600, letterSpacing: '-0.015em' },
        body1: { lineHeight: 1.7, color: '#8A8F98' },
        body2: { color: '#8A8F98', lineHeight: 1.7 },
    },
    shape: {
        borderRadius: 12,
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(15, 17, 19, 0.8)',
                    backdropFilter: 'blur(12px)',
                    boxShadow: 'none',
                    borderBottom: '1px solid rgba(255,255,255,0.06)',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: '#161819',
                    borderRadius: 12,
                    border: '1px solid rgba(255,255,255,0.08)',
                    boxShadow: 'none',
                    transition: 'border-color 200ms ease, transform 200ms ease',
                    '&:hover': {
                        borderColor: 'rgba(255,255,255,0.14)',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 500,
                    borderRadius: 8,
                    letterSpacing: '0.005em',
                },
            },
        },
        MuiModal: {
            styleOverrides: {
                root: {
                    backdropFilter: 'blur(8px)',
                },
            },
        },
    },
});

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/portfolio" element={<Portfolio />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/contact" element={<Contact />} />

                    {/* LiftLog */}
                    <Route path="/liftlog" element={<LiftLogLanding />} />
                    <Route path="/liftlog/support" element={<LiftLogSupport />} />
                    <Route path="/liftlog/terms" element={<LiftLogTerms />} />
                    <Route path="/liftlog/privacy" element={<LiftLogPrivacy />} />

                    {/* CVPro */}
                    <Route path="/cvpro/terms" element={<CVProTerms />} />
                    <Route path="/cvpro/privacy" element={<CVProPrivacy />} />

                    {/* InvoSync */}
                    <Route path="/invosync/terms" element={<InvoSyncTerms />} />
                    <Route path="/invosync/privacy" element={<InvoSyncPrivacy />} />

                    {/* Relayr */}
                    <Route path="/relayr" element={<RelayrLanding />} />
                    <Route path="/relayr/support" element={<RelayrSupport />} />
                    <Route path="/relayr/terms" element={<RelayrTerms />} />
                    <Route path="/relayr/privacy" element={<RelayrPrivacy />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
};

export default App;
